<template>
  <div class="min-h-screen flex flex-col">
    <!--DevGrid v-if="isDev" /-->

    <div class="fixed top-0 left-0 w-full z-30 pointer-events-none" v-motion-slide-top>
      <template v-if="headerVisible">
        <AppHeader v-if="!isMobile" />
        <AppHeaderMobile v-else />
      </template>

    </div>


    <main>
      <slot />

      <!-- Loader overlay phase !== 'ready' || !auth.hydrated -->
      <transition name="fade">
        <div v-if="phase !== 'ready' || !auth.hydrated || pdfExporting"
          class="fixed inset-0 flex items-center justify-center bg-workbook-orange/100 backdrop-blur-sm text-sm text-white z-20">
          <div class="relative text-center space-y-3">
            <Logo class="mx-auto mb-3"/>
            <div class="text-base font-semibold" v-if="pdfExporting">Exporting PDF…</div>
            <UButton color="white" variant="link" :loading="true">{{ pdfExporting ? 'Generating' : 'Loading' }}</UButton>
          </div>
        </div>
      </transition>
    </main>
    <AppFooter/>
    <CookieConsent />
  </div>
</template>

<script setup lang="ts">
import { ref, computed, onMounted } from 'vue'
import { useAuthStore } from '@/store/auth'
import AppHeader from '~/components/AppHeader.vue'
import AppHeaderMobile from '~/components/AppHeaderMobile.vue'
import { useWindowSize } from '@vueuse/core'

const isDev = import.meta.dev
const auth = useAuthStore()

/**
 * Fashantering för att undvika hydration-mismatch:
 *  - 'ssr' -> servermarkup
 *  - 'hydrating' -> första klientpass
 *  - 'ready' -> säkert att visa header/footer
 */
const phase = ref<'ssr' | 'hydrating' | 'ready'>('ssr')
onMounted(() => {
  phase.value = 'hydrating'
  requestAnimationFrame(() => {
    requestAnimationFrame(() => {
      phase.value = 'ready'
    })
  })
})

const { width } = useWindowSize()
const pdfExporting = useState<boolean>('pdfExporting', () => false)
const isMobile = computed(() => width.value < 767)

const headerVisible = computed(() =>
  phase.value === 'ready' &&
  auth.hydrated
)

const footerVisible = headerVisible
</script>
